/** Shared copy for employee status / inactive document rules (frontend). */

export const INACTIVE_EMPLOYEE_DOCUMENT_WRITE_MESSAGE =
  "This employee is inactive. Documents are read-only. You can still print forms. Please contact customer support to reactivate the employee.";

export const INACTIVE_EMPLOYEE_PAYROLL_WRITE_MESSAGE =
  "This employee is inactive. Time cards are read-only. Please contact customer support to reactivate the employee.";

export const INACTIVE_TO_ACTIVE_REQUIRES_SUPPORT_MESSAGE =
  "Reactivating an inactive employee requires permission. Please contact customer support to request activation.";

export function isEmployeeInactiveStatus(status) {
  return String(status || "").trim().toLowerCase() === "inactive";
}

export function normalizeEmployeeStatus(status) {
  const s = String(status || "").trim().toLowerCase();
  if (s === "active") return "Active";
  if (s === "inactive") return "Inactive";
  return status;
}
